import React, { useEffect, useRef } from 'react';
import { Zap, Shield, Users, Sparkles } from 'lucide-react';
import { trackSectionView, trackFeatureUsage } from '../utils/analytics';

const WhySection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackSectionView('why_section');
            trackFeatureUsage('why_sunspot_engagement', 'view');
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-amber-800 mb-6">
            Pourquoi choisir Sun-Spot ?
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Une approche unique pour redécouvrir votre région
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white/70 backdrop-blur-md rounded-xl p-8 text-center hover:bg-white/80 transition-all duration-200 hover:scale-105">
            <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-6">
              <Zap className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Instantané</h3>
            <p className="text-gray-600">
              Trouvez immédiatement des spots près de chez vous, sans planification complexe
            </p>
          </div>

          <div className="bg-white/70 backdrop-blur-md rounded-xl p-8 text-center hover:bg-white/80 transition-all duration-200 hover:scale-105">
            <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-6">
              <Shield className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Fiable</h3>
            <p className="text-gray-600">
              Spots vérifiés par la communauté avec informations pratiques détaillées
            </p>
          </div>

          <div className="bg-white/70 backdrop-blur-md rounded-xl p-8 text-center hover:bg-white/80 transition-all duration-200 hover:scale-105">
            <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-6">
              <Users className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Communautaire</h3>
            <p className="text-gray-600">
              Bénéficiez de l'expérience collective pour des découvertes authentiques
            </p>
          </div>

          <div className="bg-white/70 backdrop-blur-md rounded-xl p-8 text-center hover:bg-white/80 transition-all duration-200 hover:scale-105">
            <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mx-auto mb-6">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-xl font-semibold text-amber-800 mb-4">Inspirant</h3>
            <p className="text-gray-600">
              Redécouvrez la magie des petits moments et lieux qui vous entourent
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;